import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-quick-order-page',
    templateUrl: './quick-order-page.component.html',
    styleUrls: ['./quick-order-page.component.scss'],
    standalone: false
})
export class QuickOrderPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
